import axios from 'axios';

export default {
	name: 'GuiaCatalogo',
    data: () => ({
		catalogo: {
            unidad_medida: [],
            departamento: [],
            municipio: [],
            recoleccion: [],
            tipo_servicio: [],
            poblado: [],
            guia_pago: [],
            tipo_entrega: []
        }
	}),
	methods: {
		getCatalogo (lista) {
			axios
			.get(this.UrlBase + '/catalogo/get_lista?format=json', {params: {lista:lista}})
			.then(r => {
				if (r.data.exito) {
                    for (let i in r.data.lista) {
                        this.catalogo[i] = r.data.lista[i];
                    }
				} else {
					alert(r.data.mensaje);
				}
			})
			.catch(e => {
				alert(e);
			});
		}
	}
}